<template>
  <div class="position-relative ml-5 notice-info">
    <v-popover
        offset="150"
        placement="top"
    >
      <a class="btn-hw-rwd-layer"
         title="부가 정보 보기"
         data-ui="layer-guide"
         data-target="layer-popover-test"
         @click="showInformation"
      >
        <i class="fas fa-question-circle primary-color"></i>
      </a>

      <template slot="popover">
        <div class="hw-rwd-layer layer-popover-test" style="width: 720px;">
          <div class="d-flex flex-column / h-100">
            <p v-html="informationTemplate"></p>
          </div>
          <div class="layer-footer">
            <button type="button" class="layer-close hw-pill-button small" v-close-popover >확인</button>
          </div>
        </div>
      </template>
    </v-popover>
  </div>
</template>

<script>
import axios from 'axios'
import sitesInfo from "@/js/helper/sites-info";

export default {
  name: "InformationBadge",
  props:{
    informationUrl : {
      type: String,
    }
  },
  data(){
    return {
      informationTemplate : null
    }
  },
  methods:{
    showInformation(){
      if(this.informationTemplate){
        return
      }
      let url = sitesInfo.wwwHiworks + this.informationUrl
      axios.get(url)
          .then(response => {
            this.informationTemplate = response.data
          })
    }
  }
}
</script>

<style scoped>
.layer-popover-test {
  margin-left: 10px;
}
</style>